import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_TASKS_ACTION_TYPE } from '../actions';

const initialState = [];

// Merge a returned TaskDto onto the matching row in place so the table re-pills immediately.
const mergeTaskInPlace = (draft, task) => {
  const index = task ? draft.findIndex(existing => existing.taskId === task.taskId) : -1;

  if (index !== -1) {
    draft[index] = { ...draft[index], ...task };
  }
};

const subCompanyTasksReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SUB_COMPANY_TASKS_ACTION_TYPE.GET_TASKS:
        return payload || initialState;

      case SUB_COMPANY_TASKS_ACTION_TYPE.CREATE_TASK:
        if (payload) {
          draft.push(payload);
        }

        break;

      // Submit / approve return the updated TaskDto; reflect its new status in place so the
      // table re-pills immediately (TasksTab also refetches after the action for full fidelity).
      case SUB_COMPANY_TASKS_ACTION_TYPE.SUBMIT_TASK:
      case SUB_COMPANY_TASKS_ACTION_TYPE.APPROVE_TASK:
        mergeTaskInPlace(draft, payload);

        break;

      case SUB_COMPANY_TASKS_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyTasksReducer;
